import * as constants from '../constants/location.constants';

export interface ILocation {
    city: string;
    state: string;
    lat: number;
    lng: number;
}

export const defaultLocation: ILocation = {
    city: "Bengaluru",
    state: "Karnataka",
    lat: 12.9716,
    lng: 77.5946
};

/*
 * NOTE: this reducer no longer reads the `user_location` cookie itself.
 *
 * It used to, through a browser-only helper that returns null on the server.
 * The same module then produced two different initial states - the default
 * city during SSR and the saved city on the client - and hydration failed on
 * the header, discarding the tree on every page load.
 *
 * The cookie is parsed ONCE, by the server layout, and passed into the store
 * as preloadedState. One reader, one value, both renders agree.
 */
const initialState: ILocation = defaultLocation;

export const locationReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case constants.SET_LOCATION:
      return {
        ...action.payload,
      };

    default:
      return state;
  }
};
